var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeSmall svg-inline--fa css-1k33q06",
    focusable: "false",
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 640 512",
    "data-prefix": "far",
    "data-icon": "user-pen",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496.7 295.3l72.01 72.01l-125.3 125.3c-2.514 2.516-5.713 4.223-9.195 4.922l-71.42 14.29c-6.297 1.258-11.85-4.297-10.59-10.59l14.28-71.41c.6973-3.488 2.41-6.691 4.924-9.203L496.7 295.3zM629.5 255.7l-21.1-21.11c-14.06-14.06-36.85-14.06-50.91 0l-38.13 38.14l72.01 72.01l38.13-38.13C643.5 292.5 643.5 269.7 629.5 255.7zM360.1 512c.5898 0 1.189-.0586 1.797-.1797c-1.18 .2363-2.273 .0254-3.361-.1777C359.9 511.7 360.4 512 360.1 512zM96 128c0-70.69 57.31-128 127.1-128s128 57.31 128 128c0 70.69-57.31 128-128 128S96 198.7 96 128zM144 128c0 44.11 35.89 80 80 80s80-35.89 80-80c0-44.11-35.89-80-80-80S144 83.89 144 128zM326.1 464h-277.1C56.89 400.9 110.8 352 176 352h96c33.96 0 64.67 13.49 87.6 35.14l34.1-34.1C362.1 322.7 319.3 304 272 304h-96c-97.2 0-176 78.8-176 176c0 17.67 14.33 32 32 32h289.1c-1.246-5.531-1.43-11.31-.2832-17.04L326.1 464z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSettings);
export default __webpack_public_path__ + "static/media/profile-settings.c9bf08965027bc9ccd105a0798386291.svg";
export { ForwardRef as ReactComponent };